module.exports = __webpack_public_path__ + "static/ManhVu-e0dbbf36ea5e4416e7d8e5fcddb9aad4.svg";